(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('EventsPerformanceController', EventsPerformanceController);

    EventsPerformanceController.$inject = ['GeneralReportsService', 'ExpoService'];


    function EventsPerformanceController(GeneralReportsService, ExpoService) {
        var vm              = this;
        vm.getSemesters     = getSemesters;
        vm.semesterSelected = -1;
        vm.expoSelected     = '';
        vm.getExpos         = getExpos;
        vm.getByFilter      = getByFilter;        
        
        function activate() {
            vm.getSemesters();
        }

        function getSemesters() {
            vm.semesters = [];
            ExpoService.getSemesters().then(function (response) {
                angular.forEach(response.data, function(value) {
                    this.push({id : value.semester, name : value.semester });
                }, vm.semesters);
                vm.semesters.unshift({id : -1, name: '--- All ---'});
                vm.getExpos();
            });
        }

        function getExpos() {
            vm.query = {};
            vm.query['semester'] = vm.semesterSelected;
            ExpoService.getExpoBySemester(vm.query).then(function (response) {
                vm.expos = response.data;
            });
        }

        function getByFilter() {
            vm.result = {};
            vm.query = {};
            
            vm.query['semester'] = vm.semesterSelected;
            
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected;
            }

            GeneralReportsService.getEventsPerformance(vm.query).then(function (response) {
                vm.result = response.data;                       
            });
        }               

        activate();
    }

})();